// Atlas Map Engine — public API entry point.
//
// What's here today (docs/map-engine-design.md § 16):
//   - `geo/`      — pure geographic math: lat/lon ↔ vec3, haversine, bbox.
//                   No Three.js / DOM dependencies.
//   - `core/`     — Three.js globe + MapEngine class + LayerManager facade.
//   - `textures/` — multi-resolution texture loader from R2.
//   - `data/`     — normalized country/region/city datasets + loaders.
//                   Data files generated by scripts/build-data.mjs.
//   - `borders/`      — country outline rendering on the globe (consumes data/).
//   - `fills/`        — country polygon fills with state machine (selected/correct/...).
//   - `interactions/` — hover + click → country resolution via bbox + PIP.
//   - `markers/`      — clickable dots at any lat/lon (cities, country pins, etc.).
//   - `arcs/`         — animated great-circle arcs between two lat/lon points.
//
// Coming next:
//   - `debug/`          — developer panel

export * from './geo';
export * from './core';
export * from './textures';
export * from './data';
export * from './borders';
export * from './fills';
export * from './interactions';
export * from './markers';
export * from './arcs';

export const ENGINE_VERSION = '0.0.0';
